export const RANGE_PICKER_INPUT_ID = 'range-picker-input';
export const RANGE_PICKER_POPOVER_ID = 'range-picker-popover';

export enum DateRangePickerTab {
  Predefined = 'predefined',
  Custom = 'custom',
}

export const isDateRangePickerTab = (value: unknown): value is DateRangePickerTab =>
  typeof value === 'string' && Object.values(DateRangePickerTab).some(tab => tab === value);

export enum DateRangePickerTimeUnit {
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

export const isDateRangePickerTimeUnit = (value: unknown): value is DateRangePickerTimeUnit =>
  typeof value === 'string' && Object.values(DateRangePickerTimeUnit).some(unit => unit === value);

export const DEFAULT_DATE_RANGE_PICKER_VALUE = {
  predefined: undefined,
  year: undefined,
  timeValue: undefined,
  timeUnit: undefined,
  from: undefined,
  to: undefined,
} as const;
